import { render, staticRenderFns } from "./MobileRecoveryLegalMentions.vue?vue&type=template&id=63a3a0ac&scoped=true&"
import script from "./MobileRecoveryLegalMentions.vue?vue&type=script&lang=js&"
export * from "./MobileRecoveryLegalMentions.vue?vue&type=script&lang=js&"
import style0 from "./MobileRecoveryLegalMentions.vue?vue&type=style&index=0&id=63a3a0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3a0ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a3a0ac')) {
      api.createRecord('63a3a0ac', component.options)
    } else {
      api.reload('63a3a0ac', component.options)
    }
    module.hot.accept("./MobileRecoveryLegalMentions.vue?vue&type=template&id=63a3a0ac&scoped=true&", function () {
      api.rerender('63a3a0ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/recovery/MobileRecoveryLegalMentions.vue"
export default component.exports